// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"bd67eab8","355":"9b6f5944","455":"89d33f27","488":"328ec08b","575":"9edbfa88","596":"7ce1b4e8","768":"74aec773","868":"10724725","977":"e05582e0"}[chunkId] + ".chunk.js";
};